import List from "../../containers/Pages/List";
import Entry from "../../containers/Pages";

const pageRoutes = [
  {
    path: "/pages",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/pages/edit/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default pageRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/pages.jsx